import { render, staticRenderFns } from "./CommunityListAccordion.vue?vue&type=template&id=a00211ee&"
import script from "./CommunityListAccordion.vue?vue&type=script&lang=js&"
export * from "./CommunityListAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports